import {CanvasToolboxItemBase} from "@common/helpers/canvas/canvas-toolbox/canvas-toolbox-item-base"
import {CanvasToolboxItem} from "@common/helpers/canvas/canvas-toolbox/canvas-toolbox-item"

// This class is used to define a base type for toolbox items in the tiling canvas.
export class TilingCanvasToolboxItemBase<ParentItemType extends CanvasToolboxItem = CanvasToolboxItem> extends CanvasToolboxItemBase<ParentItemType> {
    readonly isTilingCanvasBaseToolboxItem = true
}
